export enum SapEtaScenarioEnum {
  SC3 = 'SC3',
  SC4 = 'SC4',
}
